import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ColorsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${props => props.theme.spacing.sp40};

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const CustomTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const TabsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`
